import { Injectable } from '@angular/core';
import * as $optionData from '../../../assets/my-theme/dg-theme-list.json';
@Injectable()
export class StyleManagerService {
  optionData = ($optionData as any).default;
  constructor() {}

  /**
   * Set the stylesheet with the specified key.
   */
  /* setStyle(href: string) {
    getLinkElementForKey('theme').setAttribute('href', href);
  } */

  /* Add Class In Body Tag */
  setStyle(addClass: string) {
    this.removeAllStyle();
    document.querySelector('body').classList.add(addClass);
  }

  /**
   * Remove the Class From Body Tag.
   */
  removeAllStyle() {
    this.optionData.forEach((item) => {
      document.querySelector('body').classList.remove(item.value);
    });
  }
}
/* function getLinkElementForKey(key: string) {
  return getExistingLinkElementByKey(key) || createLinkElementWithKey(key);
}

function getExistingLinkElementByKey(key: string) {
  return document.head.querySelector(
    `link[rel="stylesheet"].${getClassNameForKey(key)}`
  );
}

function createLinkElementWithKey(key: string) {
  const linkEl = document.createElement('link');
  linkEl.setAttribute('rel', 'stylesheet');
  linkEl.classList.add(getClassNameForKey(key));
  document.head.appendChild(linkEl);
  return linkEl;
}

function getClassNameForKey(key: string) {
  return `app-${key}`;
}
 */
